import axios from 'axios';
import { powerStatsAPI } from '../Constants';
import { LeaderboardData } from '../models/PlayerStats';

interface Team {
  teamId: string;
  teamName: string;
  teamLogo: string;
  ownerId: string | null;
  season: number;
  division: string;
  twitter: string | null;
  coachID: string | null;
  website: string | null;
  seed: string;
  playoffSeed: string;
}

interface Match {
  challonge_id: string;
  team1: Team;
  team2: Team;
  isPlayoff: boolean;
  playoffPlayed: boolean;
  division: string;
  match_time: string;
  stream_url: string | null;
  veto: any | null;
  roundNumber: number | null;
  season: number;
}

export interface PlayedMatch {
  matchid: string;
  mapName: string;
  season: number;
  team1score: number;
  team2score: number;
  team1won: boolean;
  [key: string]: any;
}

class StatsService {
  private apiUrl = powerStatsAPI;

  async getLeaderboard(season: number, steamId?: string, division?: string, group?: string): Promise<LeaderboardData> {
    try {
      const params = new URLSearchParams();
      params.append('season', season.toString());
      
      if (steamId) {
        params.append('steamId', steamId);
      }
      
      if (division) {
        params.append('division', division);
      }
      
      if (group) {
        params.append('group', group);
      }

      const response = await axios.get(`${this.apiUrl}/PlayerStat/leaderboard?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching leaderboard:', error);
      throw error;
    }
  }

  async getLatestSeason(): Promise<number> {
    try {
      const response = await axios.get(`${this.apiUrl}/Match/latestSeason`);
      return response.data;
    } catch (error) {
      console.error('Error fetching latest season:', error);
      throw error;
    }
  }

  async getOldestSeason(): Promise<number> {
    try {
      const response = await axios.get(`${this.apiUrl}/Match/oldestSeason`);
      return response.data;
    } catch (error) {
      console.error('Error fetching oldest season:', error);
      throw error;
    }
  }

  async getDivisionsBySeason(season: number): Promise<string[]> {
    try {
      const response = await axios.get(`${this.apiUrl}/Match/getDivisionsBySeason?season=${season}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching divisions:', error);
      throw error;
    }
  }

  async getUpcomingMatches(): Promise<Match[]> {
    try {
      const response = await axios.get(`${this.apiUrl}/Match/getUpcomingMatches`);
      return response.data;
    } catch (error) {
      console.error('Error fetching upcoming matches:', error);
      throw error;
    }
  }

  async getPlayedMatches(season: number): Promise<PlayedMatch[]> {
    try {
      const response = await axios.get(`${this.apiUrl}/Match/getAllMatches?season=${season}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching played matches:', error);
      throw error;
    }
  }
}

export default new StatsService();